import React, { useEffect, useState } from "react";
import TableAction from "../../TableAction";
import { Button, Input, Modal, Select, Table } from "antd";
import {
  useAddInput,
  useAddInputToOrder,
  useInputListByCategory,
  useInputListByOrderId,
} from "../../../api/input";
import { useGetMyVouchers } from "../../../api/agro_dealer";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetVouchers } from "../../../api/voucher";
import { useGetStatusCount } from "../../../hooks/useGetStatusCount";
import TableFilter from "../../TableFilter";

const GetStatusByLabel = (_label: string) => {
  let status = 2;
  switch (_label) {
    case "VOID":
      status = 1;
      break;
    case "ISSED":
      status = 2;
      break;
    case "REDEEMED":
      status = 3;
      break;
    case "PARTIALLY REDEEMED":
      status = 4;
      break;
  }
  return status;
};

const getStatusText = (_status: number) => {
  let status = "ISSUED";
  switch (_status) {
    case 1:
      status = "VOID";
      break;
    case 2:
      status = "ISSUED";
      break;
    case 3:
      status = "REDEEMED";
      break;
    case 4:
      status = "PARTIALLY REDEEMED";
      break;
  }
  return status;
};

const getStatusColor = (status: string) => {
  let color = "#FFC107";
  switch (status) {
    case "REDEEMED":
      color = "#32a852";
      break;
    case "PARTIALLY REDEEMED":
      color = "#FFA500";
      break;
    case "ISSUED":
      color = "#cc5866";
      break;
    case "VOID":
      color = "#555555";
      break;
    default:
      color = "#FFC107";
      break;
  }

  return color;
};

const columns = [
  {
    dataIndex: "voucherNo",
    title: "Voucher No.",
  },
  {
    title: "Voucher Price(ETB)",
    dataIndex: "voucherPrice",
  },
  {
    title: "Issued Date",
    dataIndex: "issuanceDate",
  },
  {
    title: "Issued By",
    dataIndex: "issuedBy",
  },
  {
    title: "Expiry Date",
    dataIndex: "expiryDate",
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (_status: number) => {
      const status = getStatusText(_status);

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "80%",
            paddingTop: 6,
            paddingBottom: 6,
            borderRadius: 8.5,
            color: getStatusColor(status),
            backgroundColor: `${getStatusColor(status)}44`,
          }}
        >
          {status}
        </div>
      );
    },
  },
];

const InputTable = () => {
  const [searchParams] = useSearchParams();
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<
    string | undefined
  >();
  const [selectedInputId, setSelectedInputId] = useState<string | undefined>();
  const [tableData, setTableData] = useState<any[]>([]);

  const navigate = useNavigate();

  const [selectedFilterIndex, setSelectedFilterIndex] = useState(0);
  const [statuses, setStatuses] = useState<string[]>([]);
  const [defaultIndex, setDefaultIndex] = useState(0);
  const filters = useGetStatusCount(statuses);

  const { data: vouchers, isLoading, refetch } = useGetVouchers();

  const handleCreate = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const onSubmit = () => {
    // if (selectedInputId && orderId) {
    //     addInputToOrder({ inputId: Number(selectedInputId), orderId: Number(orderId) });
    // }
  };

  useEffect(() => {
    if (vouchers && vouchers.data && vouchers.data.data) {
      const x = vouchers.data.data.map((item: any) => {
        return {
          id: item.id,
          voucherNo: item.voucherCode,
          voucherPrice: item.inputPayed,
          expiryDate: item.expiryDate,
          issuanceDate: item.issuanceDate,
          issuedBy: item.issuedBy.fullName,
          status: item.voucherStatus,
          inputDetails: item.entitlmentDetails,
        };
      });

      const _statuses = x.reduce((acc: any, item: any) => {
        acc[getStatusText(item.status)] =
          (acc[getStatusText(item.status)] || 0) + 1;
        return acc;
      }, {});
      console.group("_statuses", _statuses);
      setStatuses(_statuses);

      if (searchText) {
        const _data = x.filter(
          (item: any) =>
            item.voucherNo?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.issuedBy?.toLowerCase().includes(searchText.toLowerCase()),
        );

        if (selectedFilterIndex === 0) {
          setTableData(_data);
        } else {
          const _status = GetStatusByLabel(filters[selectedFilterIndex].label);
          const _filteredData = _data.filter(
            (item: any) => item.status === _status,
          );
          setTableData(_filteredData);
        }
      } else {
        if (selectedFilterIndex === 0) {
          setTableData(x);
        } else {
          const _status = GetStatusByLabel(filters[selectedFilterIndex]?.label);
          const _filteredData = x.filter(
            (item: any) => item.status === _status,
          );
          setTableData(_filteredData);
        }
      }
    }
  }, [vouchers, searchText, selectedFilterIndex]);

  useEffect(() => {
    if (searchParams) {
      const _status = searchParams.get("status");
      if (_status === "redeemed") {
        setDefaultIndex(3);
        setSelectedFilterIndex(3);
      }
    }
  }, [searchParams]);

  return (
    <>
      <div className="hidden md:block">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 80,
            backgroundColor: "#EEF3F8",
            borderRadius: 8.4,
            marginBottom: 12,
          }}
        >
          <TableAction setSearchText={setSearchText} />
        </div>
        <TableFilter
          defaultIndex={defaultIndex}
          filters={filters}
          setSelectedFilterIndex={setSelectedFilterIndex}
        />
        <div className="h-full" style={{ overflow: "hidden" }}>
          <Table
            style={{
              cursor: "pointer",
              position: "relative",
              zIndex: 100,
              overflowY: "hidden",
            }}
            scroll={{ y: 600 }}
            dataSource={tableData}
            columns={columns}
            loading={isLoading}
            onRow={(record, index) => {
              return {
                onClick: (event) => {
                  navigate(`/voucher/${record.id}`);
                },
              };
            }}
          />
        </div>
      </div>
      <div className="block md:hidden">
        <div className="w-full grid grid-col divide-y-2 divide-green-400 md:hidden px-2">
          <Input
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search"
            style={{ backgroundColor: "#08453E" }}
            className="bg-[#08453E] text-white h-[40px] my-2"
          />
          {tableData &&
            tableData.map((item: any) => {
              const status = getStatusText(item.status);

              return (
                <div
                  className="w-full flex justify-between items-center pt-2"
                  onClick={() => {
                    navigate(`/voucher/${item.id}`);
                  }}
                >
                  <div className="flex gap-4 font-bold text-lg text-white">
                    <div className="flex flex-col">
                      <div>
                        {item.voucherNo} ({item.voucherPrice} birr)
                      </div>
                      <div className="text-sm text-gray-300">
                        {item.issuedBy}
                      </div>
                      <div className="text-sm text-gray-300">
                        Issuance date - {item.issuanceDate}
                      </div>
                      <div className="text-sm text-gray-300">
                        Exp. date - {item.expiryDate}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "30%",
                      color: getStatusColor(status),
                      backgroundColor: `${getStatusColor(status)}44`,
                    }}
                    className="flex justify-center items-center py-[6px] px-3 rounded-xl"
                  >
                    {status}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default InputTable;
